import React from 'react'

import classNames from 'classnames'

import BlockContent from '~/components/atoms/BlockContent/BlockContent'
import Container from '~/components/atoms/Container/Container'
import Ctas from '~/components/atoms/Ctas/Ctas'
import Fixture from '~/components/atoms/Fixture/Fixture'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import type { ComponentTheme } from '~/components/themes'
import type { Block } from '~/services/sanity'
import { useMediaQuery } from '~/services/useMediaQuery'
import bp from '~/styles/breakpoints/breakpoints'

import styles from './CentralTitleText.module.css'

interface CentralTitleTextProps {
  title: string
  summary?: Block[]
  noPaddingBottom?: boolean
  noPaddingTop?: boolean
  smallPaddingTop?: boolean
  theme?: ComponentTheme
  verticalPadding?: boolean
  backgroundVariant?: 'light' | 'dark'
  moduleId?: string
  ctas?: any
  largerTitle?: boolean
}

export default function CentralTitleText({
  title,
  summary,
  theme,
  verticalPadding = true,
  noPaddingBottom = false,
  noPaddingTop = false,
  smallPaddingTop = false,
  backgroundVariant = 'light',
  largerTitle = false,
  moduleId,
  ctas,
}: CentralTitleTextProps) {
  const isMobile = useMediaQuery(`(max-width: ${bp.bpMedium})`)

  return (
    <Fixture
      verticalPadding={verticalPadding}
      noPaddingBottom={noPaddingBottom}
      noPaddingTop={noPaddingTop}
      smallPaddingTop={smallPaddingTop}
      theme={theme}
      id={moduleId}
      className={classNames(styles.base, styles[backgroundVariant], {
        [styles.smallVerticalPadding]: !verticalPadding,
      })}
    >
      <Container>
        <div
          className={classNames(styles.content, {
            [styles['black']]: theme === 'black',
          })}
        >
          <div className={styles.introContainer}>
            <Text
              className={classNames(styles.title, {
                [styles.largerTitle]: largerTitle,
              })}
              size={TextSizes.primaryTitleLrg}
            >
              <div dangerouslySetInnerHTML={{ __html: title }}></div>
            </Text>
            {summary && (
              <div className={classNames(styles.summary, 'prose')}>
                <BlockContent value={summary} />
              </div>
            )}
            {ctas && (
              <div className={styles.ctas}>
                <Ctas ctas={ctas} />
              </div>
            )}
          </div>
        </div>
      </Container>
    </Fixture>
  )
}
